import React, { useState } from 'react';
import SummaryApi from '../common'; // Ensure SummaryApi is imported
const EventModal = ({ event, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    event_name: event.event_name,
    category_name: event.category_name,
    event_title: event.event_title,
    event_description: event.event_description,
    event_date: event.event_date,
    event_image: event.event_image, // Start with the existing image
    new_event_image: null, // Use for the new file input
    is_active: event.is_active === "1",
  });
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : (type === 'file' ? files[0] : value),
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      event_id: event.event_id,
      is_active: formData.is_active ? "1" : "0",
    };
    console.log("Submitting payload:", payload);
    await onSave(payload);
    onClose();
  };
  const categoryOptions = [
    "select",
    "Gallery",
    "Achievements",
    "Sports Activities",
    "Cultural Activities",
    "Campus"
  ]; // Replace with your actual category options
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center mt-5">
      <div className="bg-white p-6 rounded-lg w-[50%] overflow-y-auto max-h-[90%]">
        <h2 className="text-2xl font-bold mb-4 text-center">{event.event_id ? "Edit Event" : "Create Event"}</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Event Name</label>
            <input
              type="text"
              name="event_name"
              value={formData.event_name}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Category Name</label>
            <select
              name="category_name"
              value={formData.category_name}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            >
              {categoryOptions.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Event Title</label>
            <input
              type="text"
              name="event_title"
              value={formData.event_title}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Event Description</label>
            <textarea
              name="event_description"
              value={formData.event_description}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Event Date</label>
            <input
              type="datetime-local"
              name="event_date"
              value={formData.event_date}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Event Image</label>
            {formData.event_image && (
              <div className="mb-2">
                <img
                  src={formData.event_image.startsWith("images/") ? `${SummaryApi.images.url}/${formData.event_image.replace("images/", "")}` : `${SummaryApi.images.url}/${formData.event_image}`}
                  alt="Current Event"
                  className="w-full h-32 object-cover mt-5"
                />
              </div>
            )}
            <input
              type="file"
              name="new_event_image"
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
                className="mr-2"
              />
              Active
            </label>
          </div>
          <div className="flex justify-between">
            <button
              type="button"
              onClick={onClose}
              className="mr-2 px-4 py-1 bg-gray-500 text-white rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-1 bg-blue-500 text-white rounded-md"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default EventModal;